<script lang="ts">
  import type { Snippet } from 'svelte';
  import Glow from './assets/Glow.svelte';
  import Arrow from './assets/arrow.svg?component';

  interface Props {
    animate?: boolean;
    includeGlow?: boolean;
    text?: Snippet;
  }

  let { animate = false, includeGlow = false, text }: Props = $props();
</script>

<div class="badge" class:animate>
  {#if includeGlow}
    <div class="badge__glow">
      <Glow />
    </div>
  {/if}
  <div class="badge__text">
    {@render text?.()}
  </div>

  <div class="badge__arrow">
    <Arrow />
  </div>
</div>

<style lang="scss">
  @import 'src/scss/accessibility';
  @import 'src/scss/media';

  .badge {
    width: inherit;
    height: inherit;

    &__glow {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &__text {
      position: absolute;
      width: 100%;
      height: 100%;
      animation: 18s linear 0s rotateTextOnBadge infinite;
      animation-play-state: paused;
      -webkit-animation-play-state: paused;
    }

    &__arrow {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  @include without-reduce-motion {
    @media (hover: hover) {
      .animate {
        .badge__text {
          animation-play-state: running;
          -webkit-animation-play-state: running;
        }
      }
    }
  }

  @keyframes rotateTextOnBadge {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>
